import { render, staticRenderFns } from "./SysLangSelector.vue?vue&type=template&id=007fee22&scoped=true&lang=pug&"
import script from "./SysLangSelector.vue?vue&type=script&lang=ts&"
export * from "./SysLangSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SysLangSelector.vue?vue&type=style&index=0&id=007fee22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007fee22",
  null
  
)

component.options.__file = "SysLangSelector.vue"
export default component.exports